// Plain-language labels for Truth Engine results, shared by the dashboard and admin cards.
export const CATEGORY_LABEL = {
  unsupported_statement: "Statement with no source",
  fabricated_intervention: "Care not documented as given",
  fabricated_symptom: "Symptom not in the record",
  invented_decline: "Decline not shown in the record",
  invented_medication: "Medication not in the record",
  invented_dose: "Dose not in the record",
  invented_response: "Response not documented",
  false_order: "Order not in the record",
  unsupported_score: "Score not in the record",
  unsupported_function: "Function level not in the record",
  unsupported_change: "Change not shown in the record",
  unsupported_calculation: "Calculation not supported",
  unsupported_skilled_need: "Skilled need not supported",
  unsupported_prognosis: "Prognosis not stated by a physician",
  calc_mismatch: "Calculation doesn't match",
  contradicts_source: "Contradicts the record",
  conflicting_sources: "Sources disagree",
  attribution_dropped: "Who reported it was dropped",
  misattributed: "Credited to the wrong person",
  incorrect_date: "Date doesn't match",
  patient_identity: "Patient not confirmed",
  cross_patient_evidence: "Another patient's records",
  ai_attestation: "AI-written attestation",
  fabricated_citation: "Citation not found",
  regulatory_unverified: "Unverified regulation",
  evidence_unavailable: "Records unavailable",
  verifier_unavailable: "Checker unavailable",
  not_verified: "Not checked before finalizing",
  content_changed: "Changed after the check",
  unresolved_flags: "Flags not resolved",
  not_checked: "Needs clarification",
};

export const categoryLabel = (code) => CATEGORY_LABEL[code] || String(code || "").replace(/_/g, " ");

export const MODE_META = {
  enforce: { label: "Block", hint: "Unverified AI statements can't be finalized or exported.",
    cls: "bg-red-100 text-red-800 hover:bg-red-100 dark:bg-red-950 dark:text-red-300" },
  warn: { label: "Warn", hint: "Flags are shown; clinicians can sign after writing a reason, which is kept for audit.",
    cls: "bg-amber-100 text-amber-800 hover:bg-amber-100 dark:bg-amber-950 dark:text-amber-300" },
  off: { label: "Off", hint: "No Truth Engine checks run.",
    cls: "bg-slate-100 text-slate-700 hover:bg-slate-100 dark:bg-slate-800 dark:text-slate-300" },
};

export const STATUS_META = {
  verified: { label: "Verified", cls: "bg-emerald-100 text-emerald-800 hover:bg-emerald-100 dark:bg-emerald-950 dark:text-emerald-300" },
  clarify: { label: "Clarify", cls: "bg-amber-100 text-amber-800 hover:bg-amber-100 dark:bg-amber-950 dark:text-amber-300" },
  conflict: { label: "Conflict", cls: "bg-orange-100 text-orange-800 hover:bg-orange-100 dark:bg-orange-950 dark:text-orange-300" },
  unsupported: { label: "Unsupported", cls: "bg-red-100 text-red-800 hover:bg-red-100 dark:bg-red-950 dark:text-red-300" },
};

export const SEVERITY_CLS = {
  critical: "text-red-700 dark:text-red-400",
  high: "text-orange-700 dark:text-orange-400",
  medium: "text-slate-500",
};
